"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var platform_browser_1 = require("@angular/platform-browser");
/**
 * Sanitizes strings and multilingual strings
 */
var SanitizePipe = /** @class */ (function () {
    function SanitizePipe(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    SanitizePipe.prototype.transform = function (value) {
        if (!value || (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString && value.toMap().size === 0) || (value instanceof Map && value.size === 0)) {
            return value;
        }
        else if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            return new idm_crosscutting_concepts_frontend_1.MultilingualString(this.sanitizeMapOfStrings(value.toMap()));
        }
        else if (value instanceof Map) {
            return this.sanitizeMapOfStrings(value);
        }
        else {
            return this.domSanitizer.sanitize(core_1.SecurityContext.HTML, value);
        }
    };
    SanitizePipe.prototype.sanitizeMapOfStrings = function (map) {
        var _this = this;
        var newMap = new Map();
        map.forEach(function (value, key) {
            newMap.set(key, _this.domSanitizer.sanitize(core_1.SecurityContext.HTML, value));
        });
        return newMap;
    };
    SanitizePipe = __decorate([
        core_1.Pipe({
            name: 'sanitize',
            pure: true
        }),
        __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])
    ], SanitizePipe);
    return SanitizePipe;
}());
exports.SanitizePipe = SanitizePipe;
//# sourceMappingURL=sanitize.pipe.js.map